import React, { useState, useRef, useEffect, useCallback } from 'react';
import './SearchBar.css';

const SearchBar = ({ onSearch, placeholder = "ស្វែងរកក្រុមហ៊ុន ផលិតផល ឬជម្រើសផ្សេងទៅវិញ..." }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const searchInputRef = useRef(null);

  // Handle search input changes
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  // Clear search
  const clearSearch = useCallback(() => {
    setSearchTerm('');
    onSearch('');
    searchInputRef.current?.focus();
  }, [onSearch]);

  // Handle keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ctrl/Cmd + K to focus search
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
      // Escape to clear search
      if (e.key === 'Escape' && searchTerm) {
        clearSearch();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [searchTerm, clearSearch]);

  return (
    <div className="search-container">
      <div className="search-bar">
        <div className="search-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
        </div>
        
        <input
          ref={searchInputRef}
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className="search-input"
          aria-label="ស្វែងរក"
        />
        
        {searchTerm && (
          <button
            onClick={clearSearch}
            className="clear-button"
            aria-label="សម្អាតការស្វែងរក"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        )}
        
        <div className="search-shortcut">
          <kbd>⌘</kbd>+<kbd>K</kbd>
        </div>
      </div>
      
      {isFocused && (
        <div className="search-tips">
          <p>💡 <strong>គន្លឹះស្វែងរក:</strong></p>
          <ul>
            <li>ស្វែងរកតាមឈ្មោះក្រុមហ៊ុន ឈ្មោះផលិតផល ឬឈ្មោះជម្រើសផ្សេងទៅវិញ</li>
            <li>ប្រើ <kbd>⌘</kbd>+<kbd>K</kbd> ដើម្បីផ្តោតលើការស្វែងរកយ៉ាងឆាប់</li>
            <li>ចុច <kbd>Esc</kbd> ដើម្បីសម្អាតការស្វែងរក</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
